export * from './feature.enum';
export * from './feature-group.pipe';
export * from './feature.interface';
export * from './feature.service';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/feature/shared/index.ts